import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ITask } from '@fi-shared/fi-task-shared/fi-task-shared';
import { ICommentModel } from '@fi-shared/fi-comments/fi-comments';
import { IAccessRightFilterCollection } from '@fi-shared/models';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { FiTaskHelperService } from '@fi-shared/fi-task-shared/fi-task-helper.service';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';

@Component({
    selector: 'fi-task-details-container',
    template: `
        <div class="fi-container ExtraLightBackgroundColor">
          <div class="fi-header Ccm-PageHeader">
            <div class="ccm-page-header-button-group">
              <fi-button-back-new></fi-button-back-new>
            </div>
            <div class="ccm-page-header-button-group right-aligned">
              @if (hasEditAccess()) {
                <button mat-raised-button (click)="goToEditTask()">
                  <span class="hide-mobile button-text">{{ 'common.edit' | fiAppText }}</span>
                  <span class="show-mobile button-text-small fa fa-pencil-square-o"></span>
                </button>
              }
            </div>
        
            <div class="Ccm-Header-Text"><span [textContent]="'task.details' | fiAppText"></span></div>
          </div>
          <div class="fi-content" #scrollableElement>
            <fi-task-details
              [task]="task"
              [accessRightFilterCollection]="accessRightFilterCollection"
              [comments]="comments"
              [scrollableElement]="scrollableElement"
              >
            </fi-task-details>
          </div>
        </div>
        `,
    styleUrls: ['./task-details-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-details-container' },
    standalone: false,
})
export class TaskDetailsContainerComponent implements OnInit {
    @Input() accessRightFilterCollection: IAccessRightFilterCollection;
    @Input() task: ITask;
    @Input() comments: ICommentModel[];

    constructor(
        private userDataService: FiUserDataService,
        private pageTitleService: PageTitleService,
        private taskHelperService: FiTaskHelperService,
        private fiStateService: FiStateService,
    ) {}

    ngOnInit() {
        // https://chainformation.atlassian.net/browse/FI-3805
        this.pageTitleService.setTitle(this.task.Name);
    }

    hasEditAccess(): boolean {
        return this.taskHelperService.hasEditAccess(this.task);
    }

    goToEditTask() {
        this.fiStateService.go(FiStateNames.Task.Edit, { id: this.task.Id });
    }
}
